import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from '../../tools/storage.service';
import { IxellAPIService, Roles, IUserRenault, IColorUserV1, ICtcV1, UnisiteService, StatsFeatureType } from '../../tools/api.service';
import { ActivationLight } from '../../models/activationlight';
import { HeaderService } from '../../tools/header.service';
import { ErrorService } from '../../tools/error.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from 'src/app/tools/utils';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { Constants } from '../../entities/Constants';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';


@Component({
    selector: 'app-droits',
    templateUrl: './droits.component.html',
    styleUrls: ['./droits.component.scss']
})

export class DroitsComponent implements OnInit, OnDestroy {

    isAdminLacour: boolean;
    isPreprod: boolean;
    infoPreprod: boolean = false;

    role: Roles;
    Roles = Roles;
    Utils = Utils;
    countries: any;
    droitsSource: MatTableDataSource<IUserRenault> = new MatTableDataSource<IUserRenault>();
    customersSource: MatTableDataSource<IColorUserV1> = new MatTableDataSource<IColorUserV1>();

    customersList: IColorUserV1[] = [];
    droits: any[] = [];
    languages: any[] = [];
    editUser: boolean = false;
    addUser: boolean = false;
    displayModal: boolean = false;
    displayModalAdd: boolean = false;
    displayModalError: boolean = false;
    displayModalSeeMore: boolean = false;
    messageError1: boolean = false;
    messageError2: boolean = false;
    messageError3: boolean = false;
    messageError4: boolean = false;
    delete: boolean = false;
    blocage: boolean = false;
    currentUser: IUserRenault;
    droitTemp: string = "";
    drTemp: string = "";
    languageTemp: string = "";
    countryTemp: string = "";
    showCustomer: boolean = false;
    erreur: boolean = false;
    allocate: boolean = false;
    regions: string[] = [];
    allCountry: string[] = [];
    ctcLst: ICtcV1[] = [];
    lstUsers: IUserRenault[] = [];
    selection = new SelectionModel<IColorUserV1>(true, []);
    inProgressChangeDR: boolean = false;
    saveChangeDR: boolean = false;
    enableDR: boolean = true;

    showCustomerDR: boolean = false;
    customersDRList: IColorUserV1[] = [];
    customersDRSource: MatTableDataSource<IColorUserV1> = new MatTableDataSource<IColorUserV1>();
    allocateDR: boolean = false;
    selectionDR = new SelectionModel<IColorUserV1>(true, []);

    seeMoreCustomer: IUserRenault | null = null;

    Form = new UntypedFormGroup({
        Country: new UntypedFormControl(''),
        Nom: new UntypedFormControl(''),
        Prenom: new UntypedFormControl(''),
    });

    FormCustomer = new UntypedFormGroup({
        newDR: new UntypedFormControl('', [Validators.required]),
        newCTC: new UntypedFormControl('', [Validators.required]),
    });

    FormDR = new UntypedFormGroup({
        mail: new UntypedFormControl('', [Validators.required]),
        name: new UntypedFormControl('', [Validators.required]),
        firstname: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        newDR: new UntypedFormControl('', [Validators.required]),
        unisiteCode: new UntypedFormControl(''),
        userLacour: new UntypedFormControl('')
    });

    FormDRAdd = new UntypedFormGroup({
        mail: new UntypedFormControl('', [Validators.required]),
        name: new UntypedFormControl('', [Validators.required]),
        firstname: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        newDR: new UntypedFormControl('', [Validators.required]),
        unisiteCode: new UntypedFormControl(''),
        userLacour: new UntypedFormControl('')
    });

    private roleSub: any;
    private userSub: any;
    private customerSub: any;
    private customerDRSub: any;
    private regionSub: any;
    private allCountrySub: any;
    private ctcSub: any;
    private allocateSub: any;
    private saveUserSub: any;
    private deleteUserSub: any;
    private blocageUserSub: any;
    private autoCoSub: any;
    private statsLogFeatureSub: any;

    displayedColumns = ["nom", "prenom", "langue", "Pays", "region", "lastConnection", "delete"];
    displayedColumnsCustomer = ["companySocialReason", "address", "city", "firstName", "name"]
    displayedColumnsCustomerDR = ["companySocialReason", "address", "city", "firstName", "name", "ctcName"]

    constructor(private storage: StorageService, private api: IxellAPIService, private headerService: HeaderService, private errorService: ErrorService, private router: Router, private translateService: TranslateService) { }

    /**
     *
     * */
    ngOnInit() {

        this.isPreprod = Utils.IsPreprod();

        this.headerService.changeTitle("manageaccount.droitsTitle");
        this.headerService.changeLogo(null);
        this.headerService.changeCanBack(true);

        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role;
            this.isAdminLacour = Utils.isAdminLacour(role);
        });
        this.headerService.verifyRole();

        this.languages = Utils.languages();
        if (Utils.isAdminLacour(this.role) || Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role)) {
            this.countries = Utils.countries();
        } else {
            this.countries = [];
            Utils.countries().forEach(c => {
                if (c.name == this.storage.get("country")) {
                    this.countries.push(c);
                }
            });
        }

        if (Utils.isAdminLacour(this.role) || Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isRT(this.role) || Utils.isMCI(this.role)) {
            this.displayedColumnsCustomer.push("check");
            this.displayedColumnsCustomerDR.push("check");
        }

        if (Utils.isAdminLacour(this.role)) {
            this.displayedColumns.push("droits");
            this.displayedColumns.unshift("autoConnexion");
        }

        this.displayedColumns.push("seeMore");

    }

    /**
     *
     * */
    searchUser() {
        var tmpCountry = this.Form.value.Country ?
            this.countries.find(c => c.name == this.Form.value.Country).name
            : this.countries.length == 1 ?
                this.countries[0].name
                : "";

        let language = this.storage.get("actualLanguage");
        if (language == "" || language == null)
            language = "fr";

        this.userSub = this.api.getUserRenault(tmpCountry, this.Form.value.Nom, this.Form.value.Prenom, language, moment().utcOffset() / 60).subscribe(data => {
            this.droitsSource = new MatTableDataSource(data);
            this.lstUsers = data;
        }, error => {
            if (this.userSub != null) this.userSub.unsubscribe();
        });
    }

    /**
     * 
     * @param user
     */
    deleteUserInList(user: IUserRenault) {
        this.editDroits(user);
    }

    /**
     * 
     * @param user
     */
    editDroits(user: IUserRenault) {
        //console.log(user);

        this.editUser = true;
        this.regionSub = this.api.getRegions(user.country).subscribe(data => {
            this.regions = data;
            this.currentUser = user;
            this.droitTemp = this.currentUser.droits;

            this.customerDRSub = this.api.getColorUserByCountry(this.Form.value.Country ? this.countries.find(c => c.name == this.Form.value.Country).name : "", null).subscribe(data => {
                this.customersDRList = data;
                this.customersDRSource = null;
            }, error => {
                console.log(error);
                if (this.customerDRSub != null) this.customerDRSub.unsubscribe();
            });

            this.customerSub = this.api.getColorUserByCountryAndCTC(this.Form.value.Country ? this.countries.find(c => c.name == this.Form.value.Country).name : "", this.currentUser.idCtc, null).subscribe(data => {
                if (data != null) {
                    this.customersList = data;
                } else {
                    this.customersList = [];
                }
                this.customersSource = null;
                this.displayModal = true;
            }, error => {
                console.log(error);
                if (this.customerSub != null) this.customerSub.unsubscribe();
            });

            this.FormDR.setValue({
                mail: this.currentUser.mail,
                name: this.currentUser.name,
                firstname: this.currentUser.firstname,
                phone: this.currentUser.phone,
                language: this.currentUser.language,
                country: this.currentUser.country,
                newDR: this.currentUser.dr,
                unisiteCode: this.currentUser.unisiteCode,
                userLacour: this.currentUser.userLacour
            });

            if (!Utils.isAdminLacour(this.role) && !Utils.isAdminRenault(this.role) && !Utils.isAdminRenaultPays(this.role) && !Utils.isRT(this.role) && Utils.isCTC(this.role)) {
                this.FormDR.controls.mail.disable();
                this.FormDR.controls.name.disable();
                this.FormDR.controls.firstname.disable();
                this.FormDR.controls.phone.disable();
                this.FormDR.controls.language.disable();
                this.FormDR.controls.country.disable();
                this.FormDR.controls.newDR.disable();
                this.FormDR.controls.unisiteCode.disable();
                this.FormDR.controls.userLacour.disable();
            } else {
                this.FormDR.controls.mail.enable();
                this.FormDR.controls.name.enable();
                this.FormDR.controls.firstname.enable();
                this.FormDR.controls.phone.enable();
                this.FormDR.controls.language.enable();
                this.FormDR.controls.country.enable();
                this.FormDR.controls.newDR.enable();
                this.FormDR.controls.unisiteCode.enable();
                this.FormDR.controls.userLacour.enable();
            }



            if (this.currentUser.country && (this.currentUser.country.toLowerCase() == "france" || this.currentUser.country.toLowerCase() == "spain" || this.currentUser.country.toLowerCase() == "united kingdom")) {
                if (!this.currentUser.isRT && !this.currentUser.isMCI && !this.currentUser.isCTC /*&& !this.currentUser.isInternCorporate && !this.currentUser.isClientCorporate && !this.currentUser.isAxalta && !this.currentUser.isAttum && !this.currentUser.isTechLine*/) {
                    this.enableDR = false;
                    this.FormDR.controls['newDR'].setValidators([]);
                    this.FormDR.controls['newDR'].markAsTouched();
                    this.FormDR.controls['newDR'].updateValueAndValidity();
                    this.disableDRDroits("update");
                } else {
                    this.enableDR = true;
                    this.FormDR.controls['newDR'].setValidators([Validators.required]);
                    this.FormDR.controls['newDR'].markAsTouched();
                    this.FormDR.controls['newDR'].updateValueAndValidity();
                    this.enableDRDroits("update");
                }
            }
            else {
                this.enableDR = false;
                this.FormDR.controls['newDR'].setValidators([]);
                this.FormDR.controls['newDR'].markAsTouched();
                this.FormDR.controls['newDR'].updateValueAndValidity();
            }

        }, error => {
            if (this.regionSub != null) this.regionSub.unsubscribe();
        });
    }

    openSeeMoreModal(customer: IUserRenault) {
        this.seeMoreCustomer = customer;
        this.displayModalSeeMore = true;
    }


    /**
     * 
     * @param typeForm
     */
    changeCTC(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeCTC");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.enableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitMonitoring.toString() && x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitCTCIxell.toString());
        this.ChangeDroitCurrentUser(true, false, false, false, false, false, false, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeMCI(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeMCI");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.enableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitMonitoring.toString() && x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitMCI.toString());
        this.ChangeDroitCurrentUser(false, true, false, false, false, false, false, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeRT(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeRT");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.enableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitMonitoring.toString() && x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitReferentTechnique.toString());
        this.ChangeDroitCurrentUser(false, false, true, false, false, false, false, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeAdminRenault(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeRT");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.enableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitMonitoring.toString() && x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitAdminRenault.toString());
        this.ChangeDroitCurrentUser(false, false, false, false, false, false, false, false, true, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeAdminRenaultPays(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeRT");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.enableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitMonitoring.toString() && x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitAdminRenaultPays.toString());
        this.ChangeDroitCurrentUser(false, false, false, false, false, false, false, false, false, true, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeInternCorporate(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeInternCorporate");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.disableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.InternCorporate.toString());
        this.currentUser.haveMonitoring = false;
        this.ChangeDroitCurrentUser(false, false, false, true, false, false, false, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeClientCorporate(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeClientCorporate");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.disableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.ClientCorporate.toString());
        this.currentUser.haveMonitoring = false;
        this.ChangeDroitCurrentUser(false, false, false, false, true, false, false, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeAxalta(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeAxalta");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.disableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitAxalta.toString());
        this.currentUser.haveMonitoring = false;
        this.ChangeDroitCurrentUser(false, false, false, false, false, true, false, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeAttum(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeAttum");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.disableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitAttum.toString());
        this.currentUser.haveMonitoring = false;
        this.ChangeDroitCurrentUser(false, false, false, false, false, false, true, false, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeTechLine(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeTechLine");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.disableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitTechLine.toString());
        this.currentUser.haveMonitoring = false;
        this.ChangeDroitCurrentUser(false, false, false, false, false, false, false, true, false, false, false);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     * 
     * @param typeForm
     */
    changeFournisseur(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeFournisseur");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        this.disableDRDroits(typeForm);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        droits.forEach((x, index) => {
            if (x != Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
            }
        });
        droits.push(Utils.droitFournisseur.toString());
        this.currentUser.haveMonitoring = false;
        this.ChangeDroitCurrentUser(false, false, false, false, false, false, false, false, false, false, true);
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     *
     * */
    changeMonitoring() {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changeMonitoring");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        let del: boolean = false
        droits.forEach((x, index) => {
            if (x == Utils.droitMonitoring.toString()) {
                droits.splice(index, 1);
                del = true;
            }
        });
        if (del == false)
            droits.push(Utils.droitMonitoring.toString());
        this.currentUser.haveMonitoring = !del;
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     *
     * */
    changePreprod() {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function changePreprod");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        let del: boolean = false
        droits.forEach((x, index) => {
            if (x == Utils.droitPreProd.toString()) {
                droits.splice(index, 1);
                del = true;
            }
        });
        if (del == false)
            droits.push(Utils.droitPreProd.toString());
        this.currentUser.havePreprod = !del;
        this.droitTemp = droits.join("|");
        ///* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        ///* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }

    /**
     *
     * */
    changeAccessGPI() {
        /* ---------------------------------------------------------------------------------------------------- */console.log("function changeAccessGPI");
        /* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp before", this.droitTemp);
        let droits: string[] = this.droitTemp.split("|").filter(i => i);
        /* ---------------------------------------------------------------------------------------------------- */console.log("droits before", droits);
        let del: boolean = false
        droits.forEach((x, index) => {
            if (x == Utils.DroitGPI.toString()) {
                droits.splice(index, 1);
                del = true;
            }
        });
        if (del == false)
            droits.push(Utils.DroitGPI.toString());
        this.currentUser.haveGPI = !del;
        this.droitTemp = droits.join("|");
        /* ---------------------------------------------------------------------------------------------------- */console.log("droits after", droits);
        /* ---------------------------------------------------------------------------------------------------- */console.log("this.droitTemp after", this.droitTemp);
    }


    /**
     * 
     * @param isCTC
     * @param isMCI
     * @param isRT
     * @param isInternCorporate
     * @param isClientCorporate
     * @param isAxalta
     * @param isAttum
     * @param isTechLine
     * @param isAdminRenault
     * @param isAdminRenaultPays
     * @param isFournisseur
     */
    ChangeDroitCurrentUser(isCTC: boolean, isMCI: boolean, isRT: boolean, isInternCorporate: boolean, isClientCorporate: boolean, isAxalta: boolean, isAttum: boolean, isTechLine: boolean, isAdminRenault: boolean, isAdminRenaultPays: boolean, isFournisseur: boolean) {
        this.currentUser.isCTC = isCTC;
        this.currentUser.isMCI = isMCI;
        this.currentUser.isRT = isRT;
        this.currentUser.isInternCorporate = isInternCorporate;
        this.currentUser.isClientCorporate = isClientCorporate;
        this.currentUser.isAxalta = isAxalta;
        this.currentUser.isAttum = isAttum;
        this.currentUser.isTechLine = isTechLine;
        this.currentUser.isAdminRenault = isAdminRenault;
        this.currentUser.isAdminRenaultPays = isAdminRenaultPays;
        this.currentUser.isFournisseur = isFournisseur;
    }


    /**
     * 
     * @param sort
     * @param status
     */
    sortUser(sort: Sort, status: string) {
        var data = this.lstUsers;
        Constants.sortScale(sort, status, data);

        this.lstUsers = data.slice();
        this.droitsSource = new MatTableDataSource(this.lstUsers);
    }

    /**
     * 
     * @param sort
     * @param status
     */
    sortUserCustomersDR(sort: Sort, status: string) {
        var data = this.customersDRList;
        Constants.sortScale(sort, status, data);

        this.customersDRList = data.slice();
        this.customersDRSource = new MatTableDataSource(this.customersDRList);
    }

    /**
     * 
     * @param typeForm
     */
    disableDRDroits(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function disableDRDroits");
        this.countryTemp = (typeForm == 'new') ? this.FormDRAdd.value.country : this.FormDR.value.country;
        this.enableDR = false;
        if (typeForm == 'new') {
            this.FormDRAdd.controls['newDR'].setValidators([]);
            this.FormDRAdd.controls['newDR'].markAsTouched();
            this.FormDRAdd.controls['newDR'].updateValueAndValidity();
        }
        else {
            this.FormDR.controls['newDR'].setValidators([]);
            this.FormDR.controls['newDR'].markAsTouched();
            this.FormDR.controls['newDR'].updateValueAndValidity();

        }
    }

    /**
     * 
     * @param typeForm
     */
    enableDRDroits(typeForm: string) {
        ///* ---------------------------------------------------------------------------------------------------- */console.log("function enableDRDroits");
        this.countryTemp = (typeForm == 'new') ? this.FormDRAdd.value.country : this.FormDR.value.country;
        if (this.countryTemp != "" && this.countryTemp != null && (this.countryTemp.toLowerCase() == "france" || this.countryTemp.toLowerCase() == "spain" || this.countryTemp.toLowerCase() == "united kingdom")) {
            this.enableDR = true;
            if (typeForm == 'new') {
                this.FormDRAdd.controls['newDR'].setValidators([Validators.required]);
                this.FormDRAdd.controls['newDR'].markAsTouched();
                this.FormDRAdd.controls['newDR'].updateValueAndValidity();
            }
            else {
                this.FormDR.controls['newDR'].setValidators([Validators.required]);
                this.FormDR.controls['newDR'].markAsTouched();
                this.FormDR.controls['newDR'].updateValueAndValidity();
            }
        }
    }

    /**
     *
     * */
    getCustomers() {
        this.currentUser.droits = this.currentUser.droits.replace("||||", "");
        //console.log(this.customersList);
        if (this.customersList.length > 0) {
            this.showCustomer = true;
            this.customerSub = this.api.getColorUserByCountryAndCTC(this.Form.value.Country ? this.countries.find(c => c.name == this.Form.value.Country).name : "", this.currentUser.idCtc, null).subscribe(data => {
                //console.log(data);
                if (data.length > 0) {
                    this.customersList = data;
                    this.customersSource = new MatTableDataSource(this.customersList.slice());
                    this.displayModal = true;
                    this.editUser = false;
                }
                else {
                    this.allocate = false;
                    this.showCustomer = false;
                    this.customersSource = null;
                    this.displayModal = true;
                    this.editUser = true;
                    this.customersList = [];
                }
            }, error => {
                console.log(error);
                if (this.customerSub != null) this.customerSub.unsubscribe();
            });
        }
        else {
            this.erreur = true;
        }
    }

    /**
     *
     * */
    getAllCustomersDR() {
        this.currentUser.droits = this.currentUser.droits.replace("||||", "");
        if (this.customersDRList.length > 0) {
            this.showCustomerDR = true;
            this.customerDRSub = this.api.getColorUserByCountry(this.Form.value.Country ? this.countries.find(c => c.name == this.Form.value.Country).name : "", null).subscribe(data => {
                if (data.length > 0) {
                    this.customersDRList = data;
                    this.customersDRSource = new MatTableDataSource(this.customersDRList.slice());
                    //this.customersDRSource.sortData(this.customersDRList, { active: "ctcName", direction: "asc" } as MatSort);
                    this.displayModal = true;
                    this.editUser = false;
                }
                else {
                    this.allocateDR = false;
                    this.showCustomerDR = false;
                    this.customersDRSource = null;
                    this.displayModal = true;
                    this.editUser = true;
                    this.customersDRList = [];
                }
            }, error => {
                console.log(error);
                if (this.customerDRSub != null) this.customerDRSub.unsubscribe();
            });
        }
        else {
            this.erreur = true;
        }
    }

    /**
     *
     * */
    getCustomersDR() {
        this.inProgressChangeDR = false;
        this.getAllCustomersDR();
    }

    /**
     *
     * */
    deleteUser() {
        this.deleteUserSub = this.api.deleteUser(this.currentUser).subscribe(data => {
            this.searchUser();
            this.closeModal();
        }, error => {
            if (this.deleteUserSub != null) this.deleteUserSub.unsubscribe();
        });
    }

    /**
     *
     * */
    confirmDeleteUser() {
        this.delete = true;
        this.editUser = false;
    }

    /**
     *
     * */
    cancelDeleteUser() {
        this.delete = false;
        this.editUser = true;
    }

    /**
     *
     * */
    BloquerUser() {
        //this.currentUser.bloquer = !this.currentUser.bloquer;
        this.blocageUserSub = this.api.bloquerUser(this.currentUser).subscribe(data => {
            this.searchUser();
            this.closeModal();
        }, error => {
            if (this.blocageUserSub != null) this.blocageUserSub.unsubscribe();
        });
    }

    /**
     *
     * */
    confirmBloquerUser() {
        this.blocage = true;
        this.editUser = false;
    }

    /**
     *
     * */
    cancelBloquerUser() {
        this.blocage = false;
        this.editUser = true;
    }

    /**
     * 
     * @param typeForm
     */
    changeDR(typeForm: string) {
        switch (typeForm) {
            case "new":
                this.drTemp = this.FormDRAdd.value.newDR;
                break;
            case "update":
                this.drTemp = this.FormDR.value.newDR;
        }
        if (this.customersList.length > 0) {
            this.inProgressChangeDR = true;
        }
    }

    /**
     * 
     * @param typeForm
     */
    getRegions(typeForm: string) {
        //console.log("this.countryTemp : " + this.countryTemp)
        //console.log("this.FormDRAdd.value.country : " + this.FormDRAdd.value.country)
        //console.log("this.FormDR.value.country : " + this.FormDR.value.country)
        this.countryTemp = (typeForm == 'new') ? this.FormDRAdd.value.country : this.FormDR.value.country;
        //console.log("this.countryTemp : " + this.countryTemp)
        this.currentUser.dr = "";
        this.drTemp = "";
        if (this.countryTemp != "" && this.countryTemp != null && (this.countryTemp.toLowerCase() == "france" || this.countryTemp.toLowerCase() == "spain" || this.countryTemp.toLowerCase() == "united kingdom")) {
            this.regionSub = this.api.getRegions(this.countryTemp).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionSub != null) this.regionSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionSub != null) this.regionSub.unsubscribe();
            });
            this.enableDRDroits(typeForm);
        } else {
            this.disableDRDroits(typeForm);

        }

        //if (this.countryTemp != "" && this.countryTemp != null && (this.countryTemp.toLowerCase() == "france" || this.countryTemp.toLowerCase() == "spain" || this.countryTemp.toLowerCase() == "united kingdom")) {
        //  this.enableDRDroits(typeForm);
        //}
        //else {
        //  this.disableDRDroits(typeForm);
        //}

    }

    /**
     * 
     * @param typeForm
     */
    saveCustomer(typeForm: string) {
        if (this.droitTemp != "") {
            this.currentUser.droits = this.droitTemp;
            if (this.drTemp != "") {
                this.currentUser.dr = this.drTemp;
            }
            if (this.countryTemp != "" && this.countryTemp != null) {
                this.currentUser.country = this.countryTemp;
            }
            if (this.languageTemp != "") {
                this.currentUser.language = this.languageTemp;
            }

            console.log(this.countryTemp);

            if (this.countryTemp != "" && this.countryTemp != null && (this.countryTemp.toLowerCase() == "france" || this.countryTemp.toLowerCase() == "spain" || this.countryTemp.toLowerCase() == "united kingdom") && (this.currentUser.isRT || this.currentUser.isMCI || this.currentUser.isCTC)) {
                //this.enableDRDroits(typeForm);
            } else {
                this.currentUser.dr = "";
                //this.disableDRDroits(typeForm);
            }
            var form = (typeForm == "new") ? this.FormDRAdd : this.FormDR;
            switch (typeForm) {
                case "new":
                    this.currentUser.mail = this.FormDRAdd.value.mail;
                    this.currentUser.name = this.FormDRAdd.value.name;
                    this.currentUser.firstname = this.FormDRAdd.value.firstname;
                    this.currentUser.unisiteCode = this.FormDRAdd.value.unisiteCode;
                    this.currentUser.userLacour = (this.FormDRAdd.value.userLacour) ? 1 : 0;
                    this.currentUser.phone = this.FormDRAdd.value.phone;
                    this.currentUser.language = this.FormDRAdd.value.language;
                    this.statsLogFeatureSub = this.api.statsLogFeature(StatsFeatureType.UserRenaultCreation).subscribe(() => {
                        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
                    });
                    break;
                case "update":
                    this.currentUser.mail = this.FormDR.value.mail;
                    this.currentUser.name = this.FormDR.value.name;
                    this.currentUser.firstname = this.FormDR.value.firstname;
                    this.currentUser.unisiteCode = this.FormDR.value.unisiteCode;
                    this.currentUser.userLacour = (this.FormDR.value.userLacour) ? 1 : 0;
                    this.currentUser.phone = this.FormDR.value.phone;
                    this.currentUser.language = this.FormDR.value.language;
                    this.statsLogFeatureSub = this.api.statsLogFeature(StatsFeatureType.UserRenaultEdit).subscribe(() => {
                        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
                    });
                    break;
            }

            console.log(this.currentUser);

            if (form.status == 'VALID') {
                console.log("VALID");
                this.saveUserSub = this.api.saveUserModifications(this.currentUser).subscribe(data => {
                    if (data == "") {
                        if (this.inProgressChangeDR) {
                            this.saveChangeDR = true;
                            this.editUser = false;
                        } else {
                            this.back();
                        }
                        this.closeModal();
                    } else {
                        this.OpenModalError(data);
                    }

                    if (this.isPreprod && !this.isAdminLacour) {
                        this.infoPreprod = true;
                    }

                }, error => {
                    if (this.saveUserSub != null) this.saveUserSub.unsubscribe();
                });
            }
        }
    }

    /**
     * 
     * @param typeForm
     */
    changeUserLacour(typeForm: string) {
        switch (typeForm) {
            case "new":
                this.currentUser.userLacour = (this.FormDRAdd.value.userLacour) ? 1 : 0;
                break;
            case "update":
                this.currentUser.userLacour = (this.FormDR.value.userLacour) ? 1 : 0;
                break;
        }
    }


    /**
     *
     * */
    addUserDroits() {
        this.addUser = true;
        this.displayModalAdd = true;
        this.droitTemp = "";
        this.currentUser = new IUserRenault();
        this.currentUser.isAttum = false;
        this.currentUser.isAxalta = false;
        this.currentUser.isCTC = false;
        this.currentUser.isFormateur = false;
        this.currentUser.isMCI = false;
        this.currentUser.isRT = false;
        this.currentUser.isTechLine = false;
        this.currentUser.haveMonitoring = false;
        this.currentUser.havePreprod = false;
        this.currentUser.haveGPI = false;
        this.currentUser.isAdminRenault = false;
        this.currentUser.isAdminRenaultPays = false;
        this.currentUser.isFournisseur = false;
        this.FormDRAdd.setValue({
            mail: "",
            name: "",
            firstname: "",
            phone: "",
            language: "",
            country: "",
            newDR: "",
            unisiteCode: "",
            userLacour: ""
        });
        this.enableDR = false;
        this.FormDRAdd.controls['newDR'].setValidators([]);
        this.FormDRAdd.controls['newDR'].markAsTouched();
        this.FormDRAdd.controls['newDR'].updateValueAndValidity();
    }

    /**
     * 
     * @param typeForm
     */
    saveCustomerAndSend(typeForm: string) {
        if (this.droitTemp != "") {
            this.currentUser.droits = this.droitTemp;
            if (this.drTemp != "") {
                this.currentUser.dr = this.drTemp;
            }
            if (this.countryTemp != "" && this.countryTemp != null) {
                this.currentUser.country = this.countryTemp;
            }
            if (this.languageTemp != "") {
                this.currentUser.language = this.languageTemp;
            }
            if (this.countryTemp != "" && this.countryTemp != null && (this.countryTemp.toLowerCase() == "france" || this.countryTemp.toLowerCase() == "spain" || this.countryTemp.toLowerCase() == "united kingdom") && (this.currentUser.isRT || this.currentUser.isMCI || this.currentUser.isCTC)) {
                //this.enableDRDroits(typeForm);
            } else {
                this.currentUser.dr = "";
                //this.disableDRDroits(typeForm);
            }
            var form = (typeForm == "new") ? this.FormDRAdd : this.FormDR;
            switch (typeForm) {
                case "new":
                    this.currentUser.mail = this.FormDRAdd.value.mail;
                    this.currentUser.name = this.FormDRAdd.value.name;
                    this.currentUser.firstname = this.FormDRAdd.value.firstname;
                    this.currentUser.unisiteCode = this.FormDRAdd.value.unisiteCode;
                    this.currentUser.userLacour = (this.FormDRAdd.value.userLacour) ? 1 : 0;
                    this.currentUser.phone = this.FormDRAdd.value.phone;
                    this.currentUser.language = this.FormDRAdd.value.language;
                    this.statsLogFeatureSub = this.api.statsLogFeature(StatsFeatureType.UserRenaultCreation).subscribe(() => {
                        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
                    });
                    break;
                case "update":
                    this.currentUser.mail = this.FormDR.value.mail;
                    this.currentUser.name = this.FormDR.value.name;
                    this.currentUser.firstname = this.FormDR.value.firstname;
                    this.currentUser.unisiteCode = this.FormDR.value.unisiteCode;
                    this.currentUser.userLacour = (this.FormDR.value.userLacour) ? 1 : 0;
                    this.currentUser.phone = this.FormDR.value.phone;
                    this.currentUser.language = this.FormDR.value.language;
                    this.statsLogFeatureSub = this.api.statsLogFeature(StatsFeatureType.UserRenaultEdit).subscribe(() => {
                        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
                    });
                    break;
            }
            if (form.status == 'VALID') {
                console.log("VALID");
                this.saveUserSub = this.api.saveUserModificationsAndSendId(this.currentUser, typeForm).subscribe(data => {
                    if (data == "") {
                        if (this.inProgressChangeDR) {
                            this.saveChangeDR = true;
                            this.editUser = false;
                        } else {
                            this.back();
                        }
                        this.closeModal();
                    } else {
                        this.OpenModalError(data);
                    }

                    if (this.isPreprod && !this.isAdminLacour) {
                        this.infoPreprod = true;
                    }

                }, error => {
                    if (this.saveUserSub != null) this.saveUserSub.unsubscribe();
                });
            }
        }
    }


    /**
     *
     * */
    allocateCustomers() {
        if (this.selection.selected.length > 0) {
            this.FormCustomer.reset();
            this.allocate = true;
        }
    }

    /**
     *
     * */
    allocateCustomersDR() {
        if (this.selectionDR.selected.length > 0) {
            this.FormCustomer.reset();
            this.allocateDR = true;
        }
    }

    /**
     *  Whether the number of selected elements matches the total number of rows.
     * */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.customersSource.data.length;
        return numSelected == numRows;
    }

    /**
     *  Whether the number of selected elements matches the total number of rows.
     * */
    isAllSelectedDR() {
        const numSelected = this.selectionDR.selected.length;
        const numRows = this.customersDRSource.data.length;
        return numSelected == numRows;
    }

    /**
     *  Selects all rows if they are not all selected; otherwise clear selection.
     * */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.customersSource.data.forEach(row => this.selection.select(row));
    }

    /**
     *  Selects all rows if they are not all selected; otherwise clear selection.
     * */
    masterToggleDR() {
        this.isAllSelectedDR() ?
            this.selectionDR.clear() :
            this.customersDRSource.data.forEach(row => this.selectionDR.select(row));
    }

    /**
     *
     * */
    getCtc() {
        this.ctcSub = this.api.getAllStatCtcByCountry(this.currentUser.country, this.FormCustomer.value.newDR).subscribe(data => {
            this.ctcLst = data;
        }, error => {
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        });
    }

    /**
     *
     * */
    saveAllocation() {
        let lstcolorUser: number[] = [];
        this.selection.selected.forEach(x => lstcolorUser.push(x.idcolorUser));
        this.allocateSub = this.api.reallocateColorUsers(this.FormCustomer.value.newDR, this.FormCustomer.value.newCTC, this.currentUser.idCtc, lstcolorUser).subscribe(data => {
            if (data == true) {
                this.showCustomer = true;
                this.allocate = false;
                this.FormCustomer.reset();
                this.selection.clear();
                this.getCustomers();
            }
        }, error => { if (this.allocateSub != null) this.allocateSub.unsubscribe(); });
    }

    /**
     *
     * */
    saveAllAllocationDR() {
        let lstcolorUser: number[] = [];
        this.selectionDR.selected.forEach(x => lstcolorUser.push(x.idcolorUser));
        this.allocateSub = this.api.reallocateColorUsers(this.FormCustomer.value.newDR, this.FormCustomer.value.newCTC, this.currentUser.idCtc, lstcolorUser).subscribe(data => {
            if (data == true) {
                this.showCustomerDR = true;
                this.allocateDR = false;
                this.FormCustomer.reset();
                this.selectionDR.clear();
                this.getAllCustomersDR();
            }
        }, error => { if (this.allocateSub != null) this.allocateSub.unsubscribe(); });
    }

    /**
     *
     * */
    saveAllocationDR() {
        this.closeModal();
        // this.allocateSub = this.api.reallocateColorUsersDR(this.FormCustomer.value.newDR, this.currentUser.idCtc).subscribe(data => {
        // }, error => { if (this.allocateSub != null) this.allocateSub.unsubscribe(); });
    }

    /**
     *
     * */
    back() {
        this.selection.clear();
        this.selectionDR.clear();
        this.editUser = true;
        this.showCustomer = false;
        this.allocate = false;
        this.allocateDR = false;
        this.showCustomerDR = false;
        this.inProgressChangeDR = false;
        this.saveChangeDR = false;
    }

    /**
     *
     * */
    backShowCustomer() {
        this.allocate = false;
        this.showCustomer = true;
    }

    /**
     *
     * */
    backShowCustomerDR() {
        this.allocateDR = false;
        this.showCustomerDR = true;
    }

    /**
     *
     * */
    closeModal() {
        this.editUser = false;
        this.addUser = false;
        this.erreur = false;
        this.currentUser = null;
        this.displayModal = false;
        this.displayModalAdd = false;
        this.displayModalSeeMore = false;
        this.showCustomer = false;
        this.allocate = false;
        this.allocateDR = false;
        this.showCustomerDR = false;
        this.delete = false;
        this.blocage = false;
        this.inProgressChangeDR = false;
        this.saveChangeDR = false;
        this.FormCustomer.reset();
        this.selection.clear();
        this.selectionDR.clear();
        this.droitTemp = "";
        this.drTemp = "";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModalPreprod(name: string) {
        this.infoPreprod = false;
    }

    /**
     * OpenModalError
     * @param typeError
     */
    OpenModalError(typeError: string) {
        this.displayModalError = true;
        switch (typeError) {
            case "userMailAlredyExist":
                this.messageError1 = true;
                break;
            case "userNotExist":
                this.messageError2 = true;
                break;
            case "aucunDroits":
                this.messageError3 = true;
                break;
            case "erreurInterne":
                this.messageError4 = true;
                break;
            default:
                this.messageError4 = true;
                break;
        }
    }

    /**
     * closeModalError
     */
    closeModalError() {
        this.displayModalError = false;
        this.messageError1 = false;
        this.messageError2 = false;
        this.messageError3 = false;
        this.messageError4 = false;
    }

    /**
     *
     * */
    autoConnexion(idCtc: number) {
        this.autoCoSub = this.api.getAutoConnexion(idCtc).subscribe(data => {
            this.router.navigate(['/home/' + data]);
        }, error => { if (this.autoCoSub != null) this.autoCoSub.unsubscribe(); });
    }

    /**
     *
     * */
    ngOnDestroy() {
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.userSub != null) this.userSub.unsubscribe();
        if (this.customerSub != null) this.customerSub.unsubscribe();
        if (this.customerDRSub != null) this.customerDRSub.unsubscribe();
        if (this.regionSub != null) this.regionSub.unsubscribe();
        if (this.allCountrySub != null) this.allCountrySub.unsubscribe();
        if (this.allocateSub != null) this.allocateSub.unsubscribe();
        if (this.saveUserSub != null) this.saveUserSub.unsubscribe();
        if (this.deleteUserSub != null) this.deleteUserSub.unsubscribe();
        if (this.blocageUserSub != null) this.blocageUserSub.unsubscribe();
        if (this.autoCoSub != null) this.autoCoSub.unsubscribe();
        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
    }
}
